import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EducationLevelEnum } from '@digilize/shared/definitions/src';

import { dateAfterOtherCustomErrorValidator } from '../validators/date-after-custom-error.validators';
import { dateBeforeOtherCustomErrorValidator } from '../validators/date-before-custom-error.validators';

@Injectable({
  providedIn: 'root',
})
export class FormSectionService {
  private readonly fb = inject(FormBuilder);

  createEducationFormSection(obj: EducationStep): FormGroup {
    const formGroup = this.fb.group({
      id: [obj.id],
      order: [obj.order],
      country: [obj.country],
      school_name: [obj.school_name],
      education_name: [obj.education_name],
      education_level: [obj.education_level != null ? String(obj.education_level) : null, [Validators.required]],
      level_options: this.fb.array([]),
      start_date: [obj.start_date, [dateBeforeOtherCustomErrorValidator('end_date', 'startDate')]],
      end_date: [obj.end_date, [dateAfterOtherCustomErrorValidator('start_date', 'endDate')]],
      is_current: [obj.is_current],
    });
    return formGroup;
  }
}

interface EducationStep {
  id?: string;
  order?: number;
  country?: string;
  school_name?: string;
  education_name?: string;
  education_level?: EducationLevelEnum | null;
  start_date?: string;
  end_date?: string;
  is_current?: boolean;
}
